import { Box, Tooltip } from '@mui/material';
import React from 'react';
import type { Readiness } from '../../domain/kyc/readiness';
import { StatusChip } from '../../ui/primitives';

export default function ReadinessChip({ readiness }: { readiness: Readiness }) {
  const blocking = readiness.issues.filter((issue) => issue.blocking).length;
  const warnings = readiness.issues.length - blocking;
  const chip = readiness.ready ? (
    <StatusChip
      status="READY"
      tone={warnings ? 'info' : 'success'}
      label={warnings ? `Ready · ${warnings} to watch` : 'Ready'}
    />
  ) : (
    <StatusChip status="BLOCKED" tone="danger" label={`${blocking} to resolve`} />
  );
  if (!readiness.issues.length) return chip;
  return (
    <Tooltip
      title={
        <Box component="ul" sx={{ m: 0, pl: 2 }}>
          {readiness.issues.map((issue) => (
            <li key={issue.text}>{issue.text}</li>
          ))}
        </Box>
      }
    >
      <span>{chip}</span>
    </Tooltip>
  );
}
